import { API_BASE, API_BASE_AUTH } from '../../js/util/constants.js'
import { get, post } from './api.js'

// @TODO split connections.js into manager/public folders?

// CONNECTIONS
export function callGetPublicConnections(tenantId, payload) {
  return post(
    `${API_BASE}/${tenantId}/get-public-contacts`,
    payload,
  )
}

export function callSendMessage(tenantId, connectionId, payload) {
  return post(
    `${API_BASE}/${tenantId}/send-message/${connectionId}`,
    payload,
  )
}

export function callLogContactPhoned(tenantId, connectionId) {
  return get(`${API_BASE}/${tenantId}/log-contact-phoned/${connectionId}`)
}

export function callLogContactLinkedIn(tenantId, connectionId) {
  return get(`${API_BASE}/${tenantId}/log-contact-linkedin/${connectionId}`)
}

export function callGetPublicOrganisationConnections(tenantId, payload) {
  return post(
    `${API_BASE}/${tenantId}/get-public-organisation-contacts`,
    payload,
  )
}

export function callGetConnections(tenantId, payload) {
  // const orgId = payload?.organisationId || null
  // const filters = payload?.filters || {}
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/get-contacts`,
    // ${
    //   orgId ? `/${orgId}` : ''
    // }`,
    payload,
  )
}

export function callGetOrganisationConnections(tenantId, payload) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/get-organisation-contacts`,
    payload,
  )
}

export function callGetOrganisations(tenantId) {
  return get(`${API_BASE}${API_BASE_AUTH}/${tenantId}/get-organisations`)
}

export function callGetConnection(tenantId, connectionId) {
  return get(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/get-contact/${connectionId}`,
  )
}

export function callGetPublicConnection(tenantId, connectionId, payload) {
  return post(
    `${API_BASE}/${tenantId}/get-contact/${connectionId}`,
    payload
  )
}

export function callGetHistory(tenantId, connectionId, payload) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/get-history/${connectionId}`,
    payload,
  )
}

export function callUpsertConnection(tenantId, id, payload) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/upsert-contact${
      id ? `/${id}` : ''
    }`,
    payload,
  )
}

export function callUpsertPublicConnection(tenantId, id, payload) {
  return post(
    `${API_BASE}/${tenantId}/upsert-contact${id ? `/${id}` : ''}`,
    payload,
  )
}

export function callValidateConnection(tenantId, payload) {
  return post(`${API_BASE}/${tenantId}/validate-contact`, payload)
}

export function callSaveConnection(tenantId, connectionId) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/save-contact/${connectionId}`,
  )
}

export function callUnsaveConnection(tenantId, connectionId) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/unsave-contact/${connectionId}`,
  )
}

export function callRemoveConnection(tenantId, connectionId) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/remove-contact/${connectionId}`,
  )
}

export function callEnableOrganisationConnection(tenantId, connectionId) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/enable-organisation-contact/${connectionId}`,
  )
}

export function callDisableOrganisationConnection(tenantId, connectionId) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/disable-organisation-contact/${connectionId}`,
  )
}

export function callLogActivity(tenantId, connectionId, payload) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/log-activity/${connectionId}`,
    payload,
  )
}

// REPORTS
export function callGetReports(tenantId, payload) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/get-contact-reports`,
    payload,
  )
}

export function callGetReport(tenantId, reportId) {
  return get(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/get-contact-report/${reportId}`,
  )
}

export function callGetReportsYears(tenantId) {
  return get(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/get-contact-reports-years`,
  )
}

export function callGetReportsStats(tenantId, payload) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/get-contact-reports-stats`,
    payload,
  )
}

export function callUpsertReport(tenantId, reportId, payload) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/upsert-contact-report${
      reportId ? `/${reportId}` : ''
    }`,
    payload,
  )
}

export function callRemoveReport(tenantId, reportId) {
  return post(
    `${API_BASE}${API_BASE_AUTH}/${tenantId}/remove-contact-report/${reportId}`,
  )
}
